function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#DA1919"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M59.23 36.786c.503-2.18.77-4.452.77-6.786C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30 1.253 0 2.488-.077 3.7-.226",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1) translate(6 15)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.366 14.263C40.03 5.072 32.326.5 24.249.5 16.171.5 8.304 5.073.645 14.264 8.306 23.77 16.173 28.5 24.249 28.5c8.075 0 15.779-4.728 23.117-14.237z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 14.5,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M35 9c1.333 1.923 2 3.797 2 5.622 0 1.826-.667 3.618-2 5.378M14 9c-1.333 1.923-2 3.797-2 5.622 0 1.826.667 3.618 2 5.378"
})), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M55 41L41 53.389 55 53.389 41 67.551",
  transform: "translate(1 1)"
}));

var SvgIconAllergyConjunctivitisActive = function SvgIconAllergyConjunctivitisActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 69,
    viewBox: "0 0 62 69",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAllergyConjunctivitisActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-allergy_conjunctivitis_active.98666e80.svg";
export { ForwardRef as ReactComponent };